import { render, staticRenderFns } from "./EmployeePage.vue?vue&type=template&id=aab6136e&scoped=true&"
import script from "./EmployeePage.vue?vue&type=script&lang=js&"
export * from "./EmployeePage.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePage.vue?vue&type=style&index=0&id=aab6136e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab6136e",
  null
  
)

export default component.exports